import { UserTypes } from "@courses-models/user";
import { AuthenticatedUnicUserModel, AuthenticatedUserModel } from "@courses-utils/gateway-auth";

import { authorizePortalAccess } from "@courses-pm2/api/src/ts/utils";

/**
 * Helper that'll generate the request headers needed to perform a properly
 * authorized request to the pm2 backend.
 */
export async function getRequestHeaders({ user, portalId, previewMode }: {
    portalId: string;
    user?: AuthenticatedUserModel;
    previewMode?: boolean;
}): Promise<{
    "X-PM2-Authorized": "True" | "False";
    "X-PM2-Authentication-Type": "UniLogin" | "Ekey" | "None";
    "X-PM2-User-Role": "Student" | "Teacher" | "None";
    "X-PM2-Preview": "True" | "False";
}> {
    // Determine basic authorization headers, which can be extracted directly
    // from the given user model
    const authenticationType = (
        user
            ? (
                user instanceof AuthenticatedUnicUserModel
                    ? "UniLogin"
                    : "Ekey"
            )
            : "None"
    );

    const userRole = (
        user
            ? (
                user instanceof AuthenticatedUnicUserModel && user.userType === UserTypes.STUDENT
                    ? "Student"
                    : "Teacher"
            )
            : "None"
    );

    // Determine if the user has been authorized to access content from this
    // portal
    const authorized = (
        user
            ? (
                await authorizePortalAccess(user, portalId)
                    ? "True"
                    : "False"
            )
            : "False"
    );

    return {
        "X-PM2-Authorized": authorized,
        "X-PM2-Authentication-Type": authenticationType,
        "X-PM2-User-Role": userRole,
        "X-PM2-Preview": previewMode ? "True" : "False",
    };
}
